'use strict';

var appointmentStates = {
  CREATED: 'CREATED',
  REQUESTED: 'REQUESTED',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED',
  ARCHIVED: 'ARCHIVED',
  CANCELLED: 'CANCELLED',

  // Legacy statuses (https://www.pivotaltracker.com/story/show/129876531).
  CANCELLED_BY_CLINIC: 'CANCELLED_BY_CLINIC',
  CANCELLED_BY_PATIENT: 'CANCELLED_BY_PATIENT',
  RESCHEDULED: 'RESCHEDULED',
  SCHEDULED_BY_CLINIC: 'SCHEDULED_BY_CLINIC',
  CONFIRMED: 'CONFIRMED',
};

angular.module('constants', []).constant('OpencareConstants', {
  supportUrl: 'https://opencarepractice.zendesk.com/hc/en-us',
  tutorialUrl: 'https://training.opencare.com',
  appointmentStates: appointmentStates,
  allProviders: 'allProviders',
  billingStates: {
    TO_BILL: 'TO_BILL',
    NOT_BILLED: 'NOT_BILLED',
    BILLED: 'BILLED',
    REFUNDED: 'REFUNDED',
    TRIAL: 'TRIAL',
    WRITE_OFF: 'WRITE_OFF',
    INVOICE_ISSUED: 'INVOICE_ISSUED',
  },
  calendly: {
    syncInstall: 'https://calendly.com/hilal-1/calendar-sync',
    easyBookInquiry: 'https://calendly.com/customerenablement/opencare-easy-book-enquiry',
    calendarResync: 'https://calendly.com/customerenablement/instantbook-calendar-re-synchronization-2020-clone',
    calendarSupport: 'https://calendly.com/opencaresupport/15min',
  },
  reservedAppointmentSlotStatus: {
    OPEN: 'OPEN',
    REQUESTED: 'REQUESTED',
    CONFIRMED: 'CONFIRMED',
  },
  // How a clinic prices a procedure, see the API's ClinicProcedurePriceType enum.
  clinicProcedurePriceType: {
    NOT_SET: 'NOT_SET',
    STARTS_AT: 'STARTS_AT',
    FLAT: 'FLAT',
    FREE: 'FREE',
    NOT_OFFERED: 'NOT_OFFERED',
  },
  reservedSlotNotification: {
    minNumPerProvider: 25,
  },
  // https://app.asana.com/0/315187436017019/437554418851640
  // This project is completed but we still want to show discounts for the billed appointments/invoices in the past.
  reservedSlotPromotion: {
    from: '2017-10-01',
    to: '2017-12-31',
  },
  apiDateFormat: 'YYYY-MM-DD',
  specialties: [{
    specialty: 'Dentist',
    id: 525,
  }],
  specialtyId: {
    DENTIST: 525,
    ORTHODONTIST: 584,
  },
  insuranceProviderType: {
    MEDICAL: 'MEDICAL',
    DENTAL: 'DENTAL',
  },
  // Insurance providers Opencare manages on behalf of US practices. Practice users can
  // see these plans, but only Opencare staff can change them, so that major in-network
  // providers cannot be dropped right after onboarding.
  managedInsurance: {
    // Make sure the given names correspond to the names in the database.
    providerNames: [
      'Aetna',
      'Cigna',
      'Delta Dental',
      'Guardian',
      'MetLife',
      'UnitedHealthcare',
    ],
    contactEmail: 'prime@opencare.com',
  },
  patientContactMethodOptions: [
    'Opencare messaging app',
    'Practice email outside of Opencare',
    'SMS / Text message',
    'Phone call',
    'In-person',
  ],
  automatedBilling: {
    dayStart: 6,
    hourStart: 20,
    timezone: 'America/Toronto',
  },
  appointmentHistory: {
    actionTypes: {
      AUTO_CANCELLATION_SMS: 'AUTO_CANCELLATION_SMS',
      BILLING_DEFER: 'BILLING_DEFER',
      MESSAGE: 'MESSAGE',
      NPR_DRIP_V2_SMS: 'NPR_DRIP_V2_SMS',
      OFF_HOURS_SMS: 'OFF_HOURS_SMS',
      PHONE_CALL: 'PHONE_CALL',
      PATIENT_RESPOND_RESCHEDULE_SLOTS: 'PATIENT_RESPOND_RESCHEDULE_SLOTS',
      PROVIDER_ADDED_RESCHEDULE_SLOTS: 'PROVIDER_ADDED_RESCHEDULE_SLOTS',
      RECONFIRMATION_SMS: 'RECONFIRMATION_SMS',
      RECONFIRMATION_NOT_SENT: 'RECONFIRMATION_NOT_SENT',
      RECONFIRMATION_NEGATIVE_RESPONSE: 'RECONFIRMATION_NEGATIVE_RESPONSE',
      RECONFIRMATION_POSITIVE_RESPONSE: 'RECONFIRMATION_POSITIVE_RESPONSE',
      RECONFIRMATION_LATE_RESPONSE: 'RECONFIRMATION_LATE_RESPONSE',
      RECONFIRMATION_NO_RESPONSE: 'RECONFIRMATION_NO_RESPONSE',
      RECONFIRMATION_NEGATIVE_RESPONSE_FOLLOWUP_RESCHEDULE: 'RECONFIRMATION_NEGATIVE_RESPONSE_FOLLOWUP_RESCHEDULE',
      RECONFIRMATION_NEGATIVE_RESPONSE_FOLLOWUP_CANCEL: 'RECONFIRMATION_NEGATIVE_RESPONSE_FOLLOWUP_CANCEL',
      RECONFIRMATION_NEGATIVE_RESPONSE_AUTO_RESCHEDULE: 'RECONFIRMATION_NEGATIVE_RESPONSE_AUTO_RESCHEDULE',
      STAFF_NOTE: 'STAFF_NOTE',
      STATUS: 'STATUS',
      OFFER_VALIDATION: 'OFFER_VALIDATION',
      APPT_RECONCILLED: 'APPT_RECONCILLED',
    },
    actors: {
      patient: 'patient',
      provider: 'provider',
      automatic: 'automatic',
    },
  },

  springFever: {
    CONTEST_BANNER_CLOSED: 'contestBannerViewedAndClosed',
    CONTEST_BANNER_WIN_CLOSED: 'contestEndedBannerViewedAndClosed',
    IS_COMPLETED: function(pick3UsageCount) {
      return pick3UsageCount >= 10;
    },
  },

  lessThan10IbSlotsWarning: {
    WARNING_DISPLAYED_AT: 'warningLastDisplayedAt',
    BANNER_DISPLAYED_AT: 'bannerLastDisplayedAt',
    LAST_SLOTS_INACCURATE_RESPONSE: 'lastIsInaccurateResponse',
    LAST_SLOTS_ACCURATE_RESPONSE: 'lastIsAccurateResponse',
  },

  appointmentListAlerts: {
    BULK_MESSAGING: 'BULK_MESSAGING',
  },

  manualIBExperiment: {
    MODAL_CLOSED: 'manualIBExperimentModalClosed',
  },

  maxOverdueNPRs: 4,

  providerAvailabilityBlock: {
    types: {
      DEFAULT: 'DEFAULT',
      VACATION: 'VACATION',
    },
  },

  ocProPromotionPeriod: {
    START: moment('2023-11-15').startOf('day'),
    END: moment('2023-11-22').endOf('day'),
    PROMO_DAYS_TO_SHOW: [7, 5, 3, 1, 0], // * We only want to show a modal when it's 7,5,3 and 1 days left then also on the final day of the offer promo,
    CLINICS_TO_SHOW: [
      24630727551,
      24630731410,
      24620599606,
      24630727063,
      24620598503,
      24630731900,
      24630731812,
      24630731903,
      24630635719,
      24630729255,
      24627511299,
      24630731686,
      24630731211,
      630824,
      24630729892,
      24630729907,
      24630729886,
      24630729908,
      626538,
      24630725524,
      24630727079,
      24620565770,
      24630730249,
      24630731008,
      24630728754,
      24630730839,
      24630726863,
      24630731454,
      24630731077,
      24630731278,
      24627511296,
      24630731424,
      24630727653,
      24630731053,
      24630729121,
      24630731181,
      24630729930,
      24630730934,
      24630731685,
      24621220999,
      24630731688,
      24630731786,
      24630731799,
      24630731805,
      24630731806,
      24630731837,
      24630731790,
      24630731849,
      24630731785,
      24630731768,
      24629985267,
      24630196156,
      24630731864,
      24630731808,
      24630731838,
      24630731836,
      24630731801,
      24630731833,
      24630731797,
      24630731787,
      24630731839,
      24630731802,
      24630731791,
      24630731796,
      24630731804,
      24630731798,
      24630731792,
      24630731834,
      24630731800,
      24630731793,
      24630731807,
      24630731831,
      24630731795,
      24630731828,
      24630730771,
      24630731829,
      24630728560,
      24630731830,
      24630730744,
      24630730742,
      24630730745,
      24630730832,
      24630730835,
      24630730721,
      24630256767,
      24630731666,
      24630731848,
      24630730374,
      24630731459,
      24630729341,
      24630729114,
      24630729919,
      24630240472,
      24630059661,
      24630731088,
      24630728779,
      24630731632,
      24630731439,
      24630731423,
      24630708645,
      24630729449,
      24630731814,
      24627806229,
      24630731794,
      24630731458,
      24630731273,
      24630029490,
      24630728927,
      24630730135,
      24630730840,
      24620433956,
      24630729730,
      24630728231,
      24630731955,
      24630731723,
      24630730239,
      24630731597,
      24630731755,
      24630729163,
      24630730250,
      24630731283,
      24630731268,
      24630730384,
      24630731825,
      24630731899,
      24630731715,
      24630730982,
      24625860049,
      24620569442,
      24630730109,
      24630731895,
      24630731944,
      24630731596,
      24630731894,
      24630276559,
      24630730933,
      24629983634,
      24630708526,
      24630730087,
      24630724898,
      24630730108,
      24630730110,
      24629992033,
      24630730048,
      24630731638,
      24630726558,
      24630730376,
      24630730011,
      24630730302,
      24630730065,
      24630730810,
      24630728120,
      24630618219,
      24630730242,
      24630730697,
      24629988860,
      24630730193,
      24630730012,
      24630730311,
      24630728128,
      24630094218,
      24630731226,
      621622,
      24620569045,
      24630731332,
      24630729672,
      24630731422,
      24630729173,
      24630731460,
      24630731269,
      24630727974,
      24630731263,
      24630731051,
      24630731593,
      24630729304,
      24630730367,
      24630728333,
      24630731589,
      24630731635,
      24630727508,
      24630731641,
      24630731810,
      24620598827,
      24630729848,
      24630728868,
      24630730103,
      24630731551,
      24630730606,
      24630153330,
      24620695627,
      24630730233,
      24630730232,
      24630730234,
      24630731941,
      24630728963,
      24630731953,
      24630731913,
      24630731881,
      24622202880,
      24630730062,
      24620565299,
      24630731416,
      24630731317,
      24630731152,
      24630731682,
      24630731950,
      24630731607,
      24630731757,
      24630731826,
      24630731511,
      24630731873,
      24630731917,
      24630731811,
      24622730877,
      24630260884,
      24630730080,
      24630728524,
      24630198007,
      24621023474,
      24630728264,
      24630730387,
      24630730231,
      24630728853,
      24630730303,
      24630728311,
      24630731413,
      24630728934,
      24630728300,
      24630731483,
      24630731484,
      24630731530,
      24630731492,
      24630731298,
      24630731482,
      24630731528,
      24630731485,
      24630731489,
      24630731493,
      24630731529,
      24630731491,
      24630731494,
      24630210557,
      24630000349,
      24630731729,
      24630729236,
      24630731300,
      24630728922,
      24630731962,
      24630729371,
      24630731201,
      24630731906,
      24630731928,
      24630630861,
      24630729638,
      24630730795,
      24630730377,
      24628133889,
      24630731921,
      24620598450,
      24630731235,
      24630728631,
      24630731545,
      24630731809,
      24630729891,
      24630730874,
      24630727696,
      24628723714,
      24630628803,
      24630593304,
      24622729590,
      24630723697,
      24630725521,
      24630728249,
      24630729707,
      24630730886,
      24630729325,
      24630618137,
      24630730189,
      24630731093,
      24630731202,
      24630731696,
      24630730256,
      24630729497,
      24630731860,
      24630727944,
      24630729537,
      24630731618,
      24630730429,
      24630729319,
      24630596492,
      24630731653,
      24630723674,
      24630729470,
      24630727364,
      24630729670,
      24630196084,
      24630731735,
      24630731939,
      24630709219,
      24630731954,
      24630731822,
      24630731683,
      24621255704,
      24630730077,
      24630731608,
      24630731487,
      24630731679,
      24630731574,
    ],
  },
  clinicMembership: {
    plan: {
      STARTER: 'STARTER',
      STANDARD: 'STANDARD',
      PREMIUM: 'PREMIUM',
      ELITE: 'ELITE',
    },
    status: {
      CREATED: 'CREATED',
      ACTIVE: 'ACTIVE',
      DISABLED: 'DISABLED',
    },
    appointmentPriceType: {
      FIXED: 'FIXED',
      TIERED: 'TIERED',
    },
    faqs: [
      {
        question: 'What happens to my current plan if I upgrade?',
        answer: 'Your existing benefits will be carried over, and your new plan will be prorated based on the remaining days in your billing cycle.',
      },
      {
        question: 'Can I switch back if I don’t see the value?',
        answer: 'Absolutely! You can easily switch plans or revert to your previous membership if it doesn’t meet your needs.',
      },
    ],
  },
  paymentMethod: {
    type: {
      CARD: 'card',
      BANK_ACCOUNT: 'bank_account',
    },
  },
});

var periodMap = [{
  start: 0,
  end: 9 * 60,
  label: 'Before 9am',
}, {
  start: 9 * 60,
  end: 11 * 60,
  label: '9am - 11am',
}, {
  start: 11 * 60,
  end: 13 * 60,
  label: '11am - 1pm',
}, {
  start: 13 * 60,
  end: 15 * 60,
  label: '1pm - 3pm',
}, {
  start: 15 * 60,
  end: 17 * 60,
  label: '3pm - 5pm',
}, {
  start: 17 * 60,
  end: 24 * 60,
  label: 'After 5pm',
}];

var availabilityStates = {
  LEAST_BUSY: {
    cssClass: 'least-busy',
    periodScore: 0,
  },
  NEUTRAL: {
    cssClass: 'pickable',
    periodScore: 1,
  },
  VERY_BUSY: {
    cssClass: 'very-busy',
    periodScore: 2,
  },
  CLOSED: {
    cssClass: 'closed',
    periodScore: 3,
  },
};

angular.module('constants').constant('AvailabilityConstants', {
  availabilityStates: availabilityStates,
  periodMap: periodMap,
  patientAvailabilityTimeRanges: {
    early: 'Before 9am',
    morning: '9am - 12pm',
    noon: '12pm - 2pm',
    afternoon: '2pm - 5pm',
    evening: 'After 5pm',
  },
});

angular.module('constants').constant('GenderConstants', {
  genderList: [{
    value: '',
    text: '',
  }, {
    value: 'M',
    text: 'Male',
  }, {
    value: 'F',
    text: 'Female',
  }],
});

angular.module('constants').constant('BillingContestedConstants', {
  CONTESTED: 'CONTESTED',
  RESOLVED: 'RESOLVED',
  INSURANCE_PROVIDERS: {
    CDCP: 'Canadian Dental Care Plan (CDCP)',
  },
  // Selectable billing-contested reasons. Order here defines display order.
  REASONS: {
    FREE_CONSULTATION: 'The patient attended a free consultation with no return visit booked',
    SOCIAL_ASSISTANCE: 'The patient is on a government-funded social assistance program',
    RECENT_VISIT: 'The patient has visited this practice within the last 2 years',
    MINOR: 'The patient is 17 years of age or younger',
    OTHER: 'Other',
  },
});

angular.module('constants').constant('MonthOptionsConstants', {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
});

angular.module('constants').constant('DaysOfWeek', [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]);

const PMSNames = {
  ABELDENT: 'ABELDent',
  ABELDENT_ADVANTAGE: 'ABELDent Advantage',
  CARESTACK: 'CareStack',
  CLEARDENT: 'ClearDent',
  CURVE: 'Curve',
  DENTICON: 'Denticon',
  DENTRIX: 'Dentrix',
  DENTRIX_ASCEND: 'Dentrix Ascend',
  DENTRIX_ENTERPRISE: 'Dentrix Enterprise',
  DOLPHIN: 'Dolphin',
  DRCHRONO: 'DrChrono',
  EAGLESOFT: 'Eaglesoft',
  ECLINICALWORKS: 'eClinicalWorks',
  EASY_DENTAL: 'Easy Dental',
  MOGO: 'MOGO',
  OPENDENTAL: 'OpenDental',
  ORTHOTRACT: 'OrthoTract',
  PRACTICEWORKS: 'PracticeWorks',
  PRACTICEWEB: 'PracticeWeb',
  QSI_DENTAL_WEB: 'QSI Dental Web (QDW)',
  QSI_LOCAL: 'QSI Local',
  SOFTDENT: 'SoftDent',
  TRACKER: 'Tracker',
  ULTIMO: 'Ultimo',
  OTHER: 'Other',
};

angular.module('constants').constant('PracticeManagementSoftwareConstants', [{
  name: PMSNames.ABELDENT,
  versions: [
    14,
    13,
    12,
    11,
    10,
    9,
  ],
}, {
  name: PMSNames.ABELDENT_ADVANTAGE,
  noVersion: true,
}, {
  name: PMSNames.CARESTACK,
  noVersion: true,
}, {
  name: 'ClearDent',
  versions: [
    '9',
    '10',
  ],
}, {
  name: PMSNames.CURVE,
  noVersion: true,
}, {
  name: PMSNames.DENTICON,
  noVersion: true,
}, {
  name: PMSNames.DENTRIX,
  versions: [
    'G7',
    'G6',
    'G5',
    'G5(15.1+)',
    'G4',
    'G3',
    'G2',
    '11',
  ],
}, {
  name: PMSNames.DENTRIX_ASCEND,
  noVersion: true,
}, {
  name: PMSNames.DENTRIX_ENTERPRISE,
}, {
  name: PMSNames.DOLPHIN,
  versions: [
    9,
    8,
    7,
    'Unknown',
  ],
}, {
  name: PMSNames.DRCHRONO,
}, {
  name: PMSNames.EAGLESOFT,
  versions: [
    20,
    19,
    18,
    17,
    16.10,
    16,
    15,
  ],
}, {
  name: PMSNames.EASY_DENTAL,
  versions: [
    12.1,
    12.0,
    11.4,
    11.3,
    11.2,
    11,
  ],
}, {
  name: PMSNames.ECLINICALWORKS,
  versions: [
    '10.0 or newer',
  ],
}, {
  name: PMSNames.MOGO,
}, {
  name: PMSNames.OPENDENTAL,
  versions: [
    18,
    17,
    16,
    15,
    14,
    13.2,
    13,
    12,
    11,
    10,
  ],
}, {
  name: PMSNames.ORTHOTRACT,
  versions: [
    14,
    12,
    11,
    'Unknown',
  ],
}, {
  name: PMSNames.PRACTICEWEB,
  versions: [
    '13.2 or newer',
    'Older than 13.2',
  ],
}, {
  name: PMSNames.PRACTICEWORKS,
  versions: [
    15,
    14,
    13,
    12,
    11,
  ],
}, {
  name: PMSNames.QSI_DENTAL_WEB,
  noVersion: true,
}, {
  name: PMSNames.QSI_LOCAL,
  versions: [
    'v9 or newer',
  ],
}, {
  name: PMSNames.SOFTDENT,
  versions: [
    17,
    '16.2.8',
    '16.2.5.34',
    '16.2.4.17',
    '16.2.1.16',
    '16.1.2.216',
    15,
    '14.2.6',
    14,
    13,
  ],
}, {
  name: PMSNames.TRACKER,
  versions: [
    10,
    11,
    'Unknown',
  ],
}, {
  name: PMSNames.ULTIMO,
  noVersion: true,
}, {
  name: PMSNames.OTHER,
  noVersion: true,
  isOther: true,
}]);

angular.module('constants').constant('OCEligiblePMS', [{
  name: PMSNames.ABELDENT,
  version: '(Local Only)',
}, {
  name: PMSNames.CARESTACK,
}, {
  name: PMSNames.CLEARDENT,
}, {
  name: PMSNames.CURVE,
}, {
  name: PMSNames.DENTICON,
}, {
  name: PMSNames.DENTRIX,
  version: '(G6.2+)',
}, {
  name: PMSNames.DENTRIX_ASCEND,
}, {
  name: PMSNames.EAGLESOFT,
  version: '(v17+)',
}, {
  name: PMSNames.OPENDENTAL,
  version: '(All)',
}, {
  name: PMSNames.SOFTDENT,
}, {
  name: PMSNames.TRACKER,
  version: '(v11+)',
}]);

angular.module('constants').constant('SignableDocumentsConstants', {
  // DO NOT UPDATE - Without checking the API SignedDocuments types
  // TODO: Should we change Canada to a string to keep things consistent?
  Canada: [{
    type: 'PRIVACY_POLICY',
    name: 'Privacy Policy',
    path: '/privacy',
  }, {
    type: 'TERMS_OF_SERVICE',
    name: 'Terms of Use',
    path: '/terms',
  }],
  'United States': [{
    type: 'BAA',
    name: 'HIPAA Business Associate Agreement',
    path: '/baa',
  }, {
    type: 'PRIVACY_POLICY',
    name: 'Privacy Policy',
    path: '/privacy',
  }, {
    type: 'TERMS_OF_SERVICE',
    name: 'Terms of Use',
    path: '/terms',
  }],
  lastUpdatedAt: '2021-05-13',
});

angular.module('constants').constant('AppcuesConstants', {
  nonInsuranceChecklist: '-LemPeGtDsraaopIR5w0',
  insuranceChecklist: '-MkDgPejSBeIW1-9a4-U',
});

angular.module('constants').constant('OpencareProFeatures', [{
  title: 'Connect With Patients',
  description: 'Connect with new patients and grow your practice',
  free: true,
  pro: true,
}, {
  title: 'Manage Appointments',
  description: 'Manage your schedule and appointments with ease',
  free: true,
  pro: true,
}, {
  title: 'Receive Reviews and Ratings',
  description: 'Receive reviews and ratings from satisfied patients',
  free: true,
  pro: true,
}, {
  title: 'Search Priority',
  description: 'Be at the top of patient search results in your area',
  free: false,
  pro: true,
}, {
  title: 'Return on Investment Analytics',
  footnote: '1',
  description: 'Gain insights into production, lifetime value per patient, and ROI',
  free: false,
  pro: true,
}, {
  title: 'Automated Calendar Syncing',
  description: 'Sync appointment availabilities with Opencare to streamline scheduling and reduce communication',
  free: false,
  pro: true,
}, {
  title: 'Priority Support Access',
  description: 'Get faster, personalized support from our team of experts',
  free: false,
  pro: true,
}, {
  title: 'Early Access To New Features',
  description: 'Be the first to know about new features and updates',
  free: false,
  pro: true,
}]);

angular.module('constants').constant('OpencareMembershipPlans', {
  standard: {
    title: 'Standard',
    plan: 'STANDARD',
    description: 'Gives you essential tools to receive and manage new patient requests',
    hasPrice: true,
    price: 199,
    period: 'month',
    features: [
      { title: 'Opencare Pro tools for patient management through PMS integration (Only available for specific Practice Management Software)' },
      { title: 'Be recommended to patients as an Opencare approved practice' },
      { title: 'Receive online patient requests and schedule appointments directly through the app' },
      { title: 'Message patients for easy communication and appointment confirmation' },
      { title: 'Streamlined scheduling for improved patient experience' },
      { title: 'Basic analytics for performance insights' },
      { title: 'Standard support via email and phone' },
    ],
  },
  premium: {
    title: 'Premium',
    plan: 'PREMIUM',
    bannerText: 'For Practices Ready to Grow',
    description: 'Grow your practice faster with enhanced visibility (available exclusively for Super Practice Status members)',
    hasPrice: true,
    price: 499,
    period: 'month',
    features: [
      { title: 'All Standard Features' },
      { title: 'Premium Boost for higher placement in patient searches' },
      { title: 'Priority support to address your needs faster' },
      { title: 'Increased patient request volume' },
    ],
  },
  elite: {
    title: 'Elite',
    plan: 'ELITE',
    bannerText: 'For Top-Tier Practices',
    description: 'Achieve top-tier visibility and receive exclusive support designed to help your practice dominate local searches',
    hasPrice: true,
    price: 799,
    period: 'month',
    features: [
      { title: 'All Standard Features' },
      { title: 'Elite Boost for top visibility' },
      { title: 'Dedicated success manager for strategic guidance' },
      { title: 'Exclusive early access to new Opencare features' },
      { title: 'Performance reporting' },
    ],
  },
});

angular.module('constants').constant('featureFlags', {});

angular.module('constants').constant('SuperPracticeTargets', {
  avgResponseTime: 2,
  scheduleRate: 0.7,
});
